import React from "react";
import "./Kurtlar.css";
import img from "../images/poster.jpg";

function kurtlar() {
  return (
    <div className="poster_title">
      <h2>SPECIALS</h2>
      <div className="posters">
        <a href="https://www.youtube.com/watch?v=OAatXuiQ8BY">
          <img className="poster" src={img} alt="poste_img" />
        </a>
      </div>
    </div>
  );
}

export default kurtlar;
